/**
 * CatMark — minimal continuous-line cat outline used as brand icon.
 * Renders as a clean, geometric line-art cat sitting facing forward,
 * with two pointed ears, refined body silhouette, and a small curled
 * tail extending to the right. Works from ~18px up.
 */
export const CatMark = ({ size = 30, stroke = 1.4, color = "currentColor", className = "", withFace = true }) => (
  <svg
    width={size}
    height={size * (28 / 44)}
    viewBox="0 0 44 28"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    {/* Body + ears — single closed outline */}
    <path
      d="M 6 26 L 6 12 L 10 3 L 14 12 Q 22 9.5, 30 12 L 34 3 L 38 12 L 38 26 Z"
      stroke={color}
      strokeWidth={stroke}
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
    />
    {/* Tail curling out to the right */}
    <path
      d="M 38 20 Q 43 19.5, 42.4 14.5 Q 40.5 12, 38.4 14.5"
      stroke={color}
      strokeWidth={stroke}
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
    />
    {withFace && (
      <>
        <circle cx="17" cy="16.5" r="0.9" fill={color} />
        <circle cx="27" cy="16.5" r="0.9" fill={color} />
      </>
    )}
  </svg>
);

export default CatMark;
